module.exports = __webpack_public_path__ + "8b44e161f6200f41876fbcba40577282.png";